import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { FormGroup } from '@angular/forms';
import { AdditionalOrganizationDataFormComponent } from './additional-org-data-form/additional-org-data-form.component';
import { OrganizationDetailData } from 'data-model';

@Component({
  selector: 'markant-platform-complete-org-data',
  templateUrl: './complete-org-data.component.html',
  styleUrls: ['./complete-org-data.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslocoModule, AdditionalOrganizationDataFormComponent],
})
export class CompleteOrganizationDataComponent {
  form = input.required<FormGroup>();
  organization = input.required<OrganizationDetailData>();
  showErrors = input.required<boolean>();
}
